import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Primitive, setCssUtils, setMedia, styled, css, keyframes, ThemeProvider } from '@mirohq-internal/design-system';
import { focusStyles, focusWithOffsetStyles } from './utils/styles';
import { generateFromBreakpointUtils, generateOnBreakpointUtils, generateUpToBreakpointUtils } from './utils/generators';
import { spacingUtils } from './utils/spacing';
import { BREAKPOINTS_MEDIAS } from './breakpoints';
setMedia(BREAKPOINTS_MEDIAS);

var styledUtils = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
  hasFocus: function hasFocus(_ref) {
    var withOffset = _ref.withOffset;
    return withOffset ? focusWithOffsetStyles : focusStyles;
  }
}, generateOnBreakpointUtils()), generateFromBreakpointUtils()), generateUpToBreakpointUtils()), spacingUtils);

setCssUtils(styledUtils);
export { styledUtils, styled, css, keyframes, Primitive, ThemeProvider };